import { parseTargetPeriod } from "./targetPeriod";

const namesInOrder = (lookupEntries) =>
  lookupEntries.map((entry) => entry.name);

export const compareByOrder = (order) => (a, b) =>
  order.indexOf(a) - order.indexOf(b);

export const getValueComparators = (lookups) => ({
  product: compareByOrder(namesInOrder(lookups.products)),
  horizon: compareByOrder(namesInOrder(lookups.horizons)),
  status: compareByOrder(namesInOrder(lookups.statuses)),
  priority: compareByOrder(namesInOrder(lookups.priorities)),
  impactAreas: compareByOrder(namesInOrder(lookups.impactAreas)),
  targetPeriod: (a, b) => parseTargetPeriod(a) - parseTargetPeriod(b),
});
